import React, { useMemo, useState } from 'react'
import { useTheme } from '@emotion/react'
import { VictoryContainer, VictoryPie } from 'victory'
import CustomSlice from './CustomSlice'

const getColorForPercentage = (percent, colors) => {
  if (percent <= 25) {
    return colors[0]
  } else if (percent <= 50) {
    return colors[1]
  } else if (percent <= 75) {
    return colors[2]
  }
  return colors[3]
}

const HalfCircleGauge = ({
  className,
  percent = 0,
  size = 20,
  strokeWidth = 2.5,
}) => {
  const percentNumber = typeof percent === 'string' ? Number(percent) : percent
  const theme = useTheme()
  const [firstSliceStartAngle, setFirstSliceStartAngle] = useState(0)
  const colorScale = useMemo(
    () => {
      const colors = [
        theme.color.negativeExtra.medium,
        '#FDE104',
        theme.color.brand['800'],
        '#2BC6A3',
      ]
      return [
        getColorForPercentage(percentNumber, colors),
        `rgba(${theme.color.monochrome.black_rgba}, 0.1)`,
      ]
    },
    [percentNumber, theme]
  )

  return (
    <VictoryPie
      colorScale={colorScale}
      data={[{ y: percentNumber }, { y: 100 - percentNumber }]}
      startAngle={-90}
      endAngle={90}
      innerRadius={(size - strokeWidth * 2) / 2}
      style={{ labels: { display: 'none' } }}
      // Remove width 100% style: https://commerce.nearform.com/open-source/victory/docs/common-props#width
      containerComponent={
        <VictoryContainer
          className={className}
          // Remove bottom spacing from the half pie
          style={{ marginBottom: -size / 2 }}
          responsive={false}
        />
      }
      dataComponent={
        <CustomSlice
          firstSliceStartAngle={firstSliceStartAngle}
          setFirstSliceStartAngle={setFirstSliceStartAngle}
        />
      }
      cornerRadius={100}
      padding={0}
      width={size}
      height={size}
    />
  )
}

export default HalfCircleGauge
